<template>
  <Error>
    <template>
      <span class="error-logo">403</span>
      <p class="error-text">Frobidden</p>
      <p class="error-subtext">But we're here to bring you back to safety</p>
    </template>
  </Error>
</template>

<script type="text/javascript">
  import Error from "../Error";
  export default {
    name: "Error_403",
    components: {Error}
  }
</script>